<template>
    <staticCondimentComp />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const staticCondimentComp = defineAsyncComponent(() => import('@/components/managementPages/staticCondimentPage/staticCondimentComp.vue'))
</script>